// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Zj-z","heading":"_j-z","brandPromo":"ak-z"};